<template>
  <div class="c-bottom-buttons">
    <div
      class="c-bottom-buttons__note c-bottom-buttons__note--top"
      v-if="$slots.noteTop"
    >
      <slot name="noteTop" />
    </div>
    <div class="c-bottom-buttons__buttons">
      <slot name="buttons" />
    </div>
    <div class="c-bottom-buttons__note" v-if="$slots.note">
      <slot name="note" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OBottomButtons'
}
</script>

<style lang="scss">
.c-bottom-buttons {
  background: linear-gradient(
    to bottom,
    rgba(#fff, 0),
    rgba(#fff, 1) 30%,
    rgba(#fff, 1)
  );
  bottom: 0;
  left: 0;
  padding: 1.6rem;
  position: absolute;
  right: 0;
}

.c-bottom-buttons__buttons {
  & > * + * {
    margin-top: 0.8rem !important;
  }
}

.c-bottom-buttons__note {
  color: $gray-500;
  font-size: 1.4rem;
  line-height: 2rem;
  margin-top: 0.8rem;
  text-align: center;

  a {
    color: $primary-color;
    color: var(--primary-color);
  }

  p {
    margin: 0;
  }
}

.c-bottom-buttons__note--top {
  margin-bottom: 0.8rem;
}
</style>
